import { render, staticRenderFns } from "./FomulaConfigTable.vue?vue&type=template&id=164f8c62&scoped=true&"
import script from "./FomulaConfigTable.vue?vue&type=script&lang=js&"
export * from "./FomulaConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./FomulaConfigTable.vue?vue&type=style&index=0&id=164f8c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f8c62",
  null
  
)

export default component.exports